import React, { useState } from 'react';
import { LogOut, Menu, User } from 'lucide-react';
import { useUserStore } from '../store/AuthUserStore';
import { useNavigate } from 'react-router-dom'


interface NavbarProps {
  onMenuClick: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ onMenuClick }) => {

  const [isDropdownOpen, setDropdownOpen] = useState(false);
 
  const navigate = useNavigate(); 

  const user = useUserStore((state) => state.user);
  const logout = useUserStore((state) => state.logout);


    const handleLogout = () => {
    logout(); 
    navigate('/login');
   
  };

  return (
    <>
      <div className=' bg-white h-16'>
        <div className='flex items-center justify-between h-full px-4 md:px-6'>
          <div className='flex items-center gap-3'>
            <button onClick={onMenuClick} className="lg:hidden">
              <Menu size={20} color='black' strokeWidth={2}/>
            </button>
            <div className='text-black text-xl font-semibold'>Little LilyERP</div>
          </div>

         <div className="relative mr-4">
          <button onClick={() => setDropdownOpen(!isDropdownOpen)}>
            <User color="black" size={20} />
          </button>

          {/* Dropdown card */}
          {/* {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-32 p-1 bg-white border border-gray-200  rounded-lg shadow-lg z-50">
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg"
              >
                <LogOut size={16} /> Logout
              </button>
            </div>
          )} */}
           {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
             
              {user && (
                <div className="px-4 py-2 border-b border-gray-200">
                  <p className="font-semibold text-sm text-gray-800 truncate">
                    {user.fullName}
                  </p>
                  <p className="text-xs text-gray-500 capitalize">
                    {user.userRole}
                  </p>
                </div>
              )}

            
              <div className="p-0">
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 w-full px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-md"
                >
                  <LogOut size={16} /> Logout
                </button>
              </div>
            </div>
          )}
        </div>
        </div>
      </div>
    </>
  );
}

